import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import {
  GetScreenActionPermissionsEntity,
  UserWalletManageService,
} from 'services/openapi';

import { ManagementServiceQueryKeys } from '../constants';

export const useGetScreenActionPermissionsQuery = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  const queryKey = [ManagementServiceQueryKeys.GET_MANAGEMENT_LIST];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetScreenActionPermissionsEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletManageService.userManageControllerGetScreenActionPermissions(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...QUERY_CACHE_CONFIG.REFERENCE_DATA,
    enabled: enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
